import { IconType } from 'react-icons';

interface FeatureSectionProps {
  Icon: IconType;
  name: string;
  children: React.ReactNode;
}

function FeatureSection({
  Icon,
  name,
  children,
}: FeatureSectionProps): JSX.Element {
  return (
    <div className="relative">
      <dt>
        <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-brand-yellow text-white">
          <Icon className="h-6 w-6" aria-hidden="true" />
        </div>
        <p className="ml-16 text-lg font-medium leading-6 text-gray-900">
          {name}
        </p>
      </dt>
      <dd className="ml-16 mt-2 text-base text-gray-500">{children}</dd>
    </div>
  );
}

export default FeatureSection;
